<script setup lang="ts">
import BoxComponent from '../atoms/BoxComponent.vue'
import ButtonComponent from '../atoms/ButtonComponent.vue'
import FlexComponent from '../atoms/FlexComponent.vue'
import TypographyComponent from '../atoms/TypographyComponent.vue'

import DialogModal from './DialogModal/DialogModal.vue'

withDefaults(
  defineProps<{
    title?: string
    description?: string
    isLoading?: boolean
    submitBtnText?: string
    submitBtnVariant?: 'primary' | 'secondary' | 'outlined' | 'text' | 'transparent' | 'danger'
  }>(),
  {
    submitBtnText: 'Delete',
    submitBtnVariant: 'danger',
  },
)
const emits = defineEmits<{ onSubmit: [] }>()
const isOpen = defineModel<boolean>('modelValue', { default: false })
</script>
<template>
  <DialogModal v-model="isOpen" @before-close="() => (isOpen = false)">
    <template #header>
      <slot v-if="$slots.header" name="header" />
      <TypographyComponent v-if="title" variant="headline-medium">{{ title }}</TypographyComponent>
    </template>

    <template #default>
      <BoxComponent v-if="description" :mt="16" :mb="24">
        <TypographyComponent variant="body-large">
          {{ description }}
        </TypographyComponent>
      </BoxComponent>
      <slot v-if="$slots.default" name="default" />
      <FlexComponent :gap="8" justify="flex-end">
        <ButtonComponent variant="text" :is-disabled="isLoading" @click="() => (isOpen = false)">Cancel</ButtonComponent>
        <ButtonComponent :variant="submitBtnVariant" :is-loading="isLoading" @click="emits('onSubmit')">
          {{ submitBtnText }}
        </ButtonComponent>
      </FlexComponent>
    </template>
  </DialogModal>
</template>
